import { render, staticRenderFns } from "./follow_prescription.vue?vue&type=template&id=50e0d821&scoped=true"
import script from "./follow_prescription.vue?vue&type=script&lang=js"
export * from "./follow_prescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0d821",
  null
  
)

export default component.exports